// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import FloatingTooltip, { FloatingTooltipProps } from "@werner/App/Components/FloatingTooltip/FloatingTooltip";
import { tooltipDefaultProps } from "@werner/App/Components/FloatingTooltip/presentationProps";
import React, { FC } from "react";
import { css } from "styled-components";

interface FloatingMeuTooltipProps extends FloatingTooltipProps {
    children: React.ReactNode;
    referenceId?: string;
    equalHeight?: boolean;
    height?: number;
    maxWidth?: number | "none";
}

type Props = FloatingMeuTooltipProps;

const DEFAULT_BOUNDARY_SELECTOR = "#header-container";

const FloatingMenuTooltip: FC<Props> = ({ children, referenceId, equalHeight, height, extendedStyles, ...props }) => {
    const resolvedExtendedStyles = equalHeight
        ? {
              ...extendedStyles,
              tooltipContent: {
                  ...extendedStyles?.tooltipContent,
                  css: css`
                      box-sizing: border-box;
                      display: flex;
                      height: ${height ?? 454}px;
                      padding: 0;
                      ${extendedStyles?.tooltipContent?.css}

                      > * {
                          height: 100%;
                      }
                  `,
              },
          }
        : extendedStyles;

    return (
        <FloatingTooltip
            {...props}
            extendedStyles={resolvedExtendedStyles}
            shift={{
                ...(props.shift || tooltipDefaultProps.shift),
                boundary:
                    typeof document !== "undefined"
                        ? document.querySelector(referenceId ?? DEFAULT_BOUNDARY_SELECTOR) || document.body
                        : "clippingAncestors",
            }}
        >
            {children}
        </FloatingTooltip>
    );
};

export default FloatingMenuTooltip;
